import { FinancialLineItemType } from '@modeso/types__aumico-lib-settings-be';

export interface ISettings {
    accountBases: string[];
    legalForms: string[];
}

export interface IFinancialLineItem {
    _id: string;
    name: string;
    position: number;
    type: FinancialLineItemType;
    description: { [key: string]: string };
    selected?: boolean;
}
